import { ignoreDuplicate } from '@repo/redux/actions/duplicates';
import { ActionArchiveIcon, ActionIgnoreIcon, ActionMergeIcon } from '@repo/icons';
import { DuplicatesViewState } from '@repo/utils/types';
import { Dispatch } from 'redux';
import { archiveContactBatch, mergeContactBatch } from './contactBatchActions';
import Duplicate from '@repo/utils/models/Duplicate';

export const mergeDuplicateMemberProfiles = (duplicate: Duplicate, dispatch: Dispatch) => {
  if (!duplicate) {
    return;
  }

  mergeContactBatch(duplicate.contactIDs, 'Duplicates View', dispatch, duplicate.id)();
};

export const archiveDuplicateMemberProfiles = (duplicate: Duplicate, dispatch: Dispatch) => {
  if (!duplicate) {
    return;
  }

  archiveContactBatch(duplicate.contactIDs, 'Duplicates View', dispatch);
};

export const buildDuplicateActions = (
  duplicatesViewState: DuplicatesViewState | null,
  dispatch: Dispatch,
) => {
  if (!duplicatesViewState) {
    return [];
  }

  const { selectedDuplicate } = duplicatesViewState;

  if (!selectedDuplicate || selectedDuplicate.isMerging || selectedDuplicate.isTransitioningOut) {
    return [];
  }

  return [
    {
      title: 'Merge profiles',
      type: 'action',
      action: () => mergeDuplicateMemberProfiles(selectedDuplicate, dispatch),
      icon: ActionMergeIcon,
    },
    {
      title: 'Ignore profiles',
      type: 'action',
      action: () => dispatch(ignoreDuplicate(selectedDuplicate.id)),
      icon: ActionIgnoreIcon,
    },
    {
      title: 'Archive profiles',
      type: 'action',
      action: () => archiveDuplicateMemberProfiles(selectedDuplicate, dispatch),
      icon: ActionArchiveIcon,
    },
  ];
};
